import { render, staticRenderFns } from "./SpecialSpecialtyEdit.vue?vue&type=template&id=ffe3d1d0&scoped=true&"
import script from "./SpecialSpecialtyEdit.vue?vue&type=script&lang=js&"
export * from "./SpecialSpecialtyEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffe3d1d0",
  null
  
)

export default component.exports